export const paths = {
  home: "/",
  auth: {
    signIn: "/auth/sign-in",
    signUp: "/auth/sign-up",
    resetPassword: "/auth/reset-password",
  },
  console: {
    /**
     * 可通过侧导航直接访问
     */
    index: `/console`,
    copilot: "/console/copilot",
    settings: "/console/settings",
    watchlist: "/console/watchlist",
    history: "/console/history",
    onePager: "/console/onepager",
    filings: "/console/filings",

    /**
     * 通过其他位置间接访问
     */
    analysis: `/console/analysis`,
    dashboard: "/console/dashboard",
    screener: "/console/screener",
  },
  checkout: `/checkout`,
} as const;

const defaultCode = "AAPL.NASDAQ";
const defaultName = "Apple Inc.";
export const defaultInitialPath =
  paths.console.analysis + `/${defaultCode}?stockName=${defaultName}`;
